import React, { Component } from "react";

export default class listWhite extends Component {
  render() {
    return (
    
<svg className={this.props.className} onClick={this.props.onClick} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.33203 6H13.9987" stroke="#1063EA" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M2 6H2.00667" stroke="#1063EA" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M5.33398 10H14.0007" stroke="#1063EA" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M2 10H2.00667" stroke="#1063EA" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
</svg>
    );
  }
}
